// extracted by mini-css-extract-plugin
export default {"container":"home_container__-TNrP","title":"home_title__q21Py","cardContainer":"home_cardContainer__QWZIP"};